// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL:  "https://darkviolet-mandrill-145960.hostingersite.com/",
});

export default axiosInstance;

export const weburl = "https://darkviolet-mandrill-145960.hostingersite.com/";
// export const weburl = "https://listmein.onrender.com/";

export const Homeurl = "https://listmein.spacedeco.in/";
export const adminurl = "https://adminlistmein.spacedeco.in/";
export const keyLogin = '6790eedec0468755d4a7a631';
export const LiveURL = 'https://secure.payu.in/_payment';
export const TestURL = 'https://test.payu.in/_payment';
export const MAPKEY = 'AIzaSyDYsdaR0zrPsBDeuyCKFH_4PuCUyWcQ2mE';


// export const weburl = 'https://backend-2o7f.onrender.com/';
